import { HqApiService } from './hqApiService';
import { GetWorkerProfileResponse } from './worker-service.types';

export class WorkerService {
  constructor(private readonly ogpApiService: HqApiService) {}

  public getPartnerWorkerProfile = async (workerId: string): Promise<GetWorkerProfileResponse> => {
    const result = await this.ogpApiService.get<GetWorkerProfileResponse>({
      path: `workers/${workerId}/profile`,
    });

    return result;
  };
}
